import { render, staticRenderFns } from "./MigrationLink.vue?vue&type=template&id=1630e6e0&scoped=true"
import script from "./MigrationLink.vue?vue&type=script&lang=js"
export * from "./MigrationLink.vue?vue&type=script&lang=js"
import style0 from "./MigrationLink.vue?vue&type=style&index=0&id=1630e6e0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630e6e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1630e6e0')) {
      api.createRecord('1630e6e0', component.options)
    } else {
      api.reload('1630e6e0', component.options)
    }
    module.hot.accept("./MigrationLink.vue?vue&type=template&id=1630e6e0&scoped=true", function () {
      api.rerender('1630e6e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Migration/MigrationLink.vue"
export default component.exports